module.exports = __webpack_public_path__ + "static/media/diversity.25250ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/diversity.png
// module id = 385
// module chunks = 0